export default {"src":"/_next/static/media/left-arrow.d16353d0.svg","height":24,"width":14};